<template lang="html">
  <si-container>
    <v-flex>
      <v-layout mt-4>
        <v-flex shrink>
          <SiUserAvatar
            :uid="_user.uid"
            size="32"
            class="mt-3"
          />
        </v-flex>
        <v-flex>
          <SiQuill
            v-model="note"
            :image-save-path="path"
            rounded-corners
            @keydown="handleEditorKeydown"
          />

          <v-card-actions class="px-0 pb-0">
            <v-spacer />
            <v-btn
              v-if="editId"
              color="grey"
              text
              @click="handleCancelEdit"
            >
              Cancel
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="handlePostNote"
            >
              {{ !editId ? 'Add note' : 'update' }}
            </v-btn>
          </v-card-actions>
        </v-flex>
      </v-layout>
      <v-divider class="mb-4" />

                  
      <v-scale-transition group>
        <v-layout
          v-for="note in notes"
          :key="note.id"
        >
          <v-flex shrink>
            <SiUserAvatar
              :uid="note.uid"
              size="32"
              class="mt-2"
            />
          </v-flex>
          <v-flex>
            <v-card outlined>
              <v-card-title class="body-2 px-3 py-2 grey lighten-4">
                <span class="font-weight-bold mr-2">{{ _userName(note.uid) }}</span>
                <span class="caption grey--text">{{ _formatDateTime(note.timestamp) }}</span>
                <span
                  v-if="note.edited"
                  class="caption grey--text"
                > <span class="font-weight-bold mx-2">•</span>edited: {{ _formatDateTime(note.edited) }}</span>
                <v-spacer />
                <v-btn
                  v-if="note.id === editId"
                  text
                  color="grey"
                  small
                  @click="handleCancelEdit"
                >
                  Cancel Edit
                </v-btn>
                <v-btn
                  v-if="note.id !== editId"
                  text
                  icon
                  color="grey"
                  small
                  @click="handleEditNote(note)"
                >
                  <v-icon small>
                    edit
                  </v-icon>
                </v-btn>
                <SiDeleteButton 
                  v-if="note.id !== editId" 
                  title="Delete note?" 
                  message="Are you sure you want to delete this note" 
                  @delete="handleDeleteNote(note.id)"
                >
                  <template #activator="{ attrs, on }">
                    <v-btn
                      v-bind="attrs"
                      text
                      icon
                      color="grey"
                      small
                      v-on="on"
                    >
                      <v-icon small>
                        close
                      </v-icon>
                    </v-btn>
                  </template>
                </SiDeleteButton>
              </v-card-title>
              <v-card-text
                class="si-note-body pa-3"
                v-html="note.note"
              />
            </v-card>
          </v-flex>
        </v-layout>
      </v-scale-transition>
    </v-flex>
  </si-container>
</template>

<script>
import { mapGetters } from 'vuex'
import helpers from '@/mixins/helpers'
import binder from '@/mixins/binder'
import users from '@/mixins/users'

import { rtdb } from '@/plugins/firebase'
export default {
  mixins: [ helpers, binder, users ],
  props: {
    calculatorId: String,
  },
  data () {
    return {
      note: '',
      notes: '',
      tab: 'edit',
      editId: null,
      editNote: ''
    }
  },
  computed: {
     ...mapGetters(['_loader', '_user', '_badgeTotals']),
    path () {
      return `calculators/${this.calculatorId}/notes`
    },
  },
  watch: {
    '$route.params.sub' () {
      this.bindNotes()
    },
    '$route.params.id' () {
      this.bindNotes()
    }
  },
  beforeMount () {
    this.bindNotes()
  },
  methods: {
    bindNotes () {
      this.loading = false

      this.$unbindAll()

      if (this.$route.params.id === 'notes') {
        const callback = (v) => this.notes = this._sortObject(v).reverse()
        this.$bindRtdb('notes', this.path, { callback })
        // this.$bindxxx(rtdb.ref(this.path), v => {
        //   // this.onResize()
        //   // this.notes = v
        //   this.notes = this._sortObject(v).reverse()
        //   // this.$nextTick(() => this.isDirty = false )
        // })
      }
    },
    handlePostNote () {
      if (!this.note) return
      if (!this.editId) {
        rtdb.ref(`${this.path}`).push({
          timestamp: new Date().toISOString(),
          note: this.note,
          uid: this._user.uid
        })
      } else {
        rtdb.ref(`${this.path}/${this.editId}`).update({ note: this.note, edited: new Date().toISOString()})
      }
      
      this.editId = null
      this.note = ''
    },
    handleUpdateNote () {
      this.note = ''
    },
    handleDeleteNote (id) {
      rtdb.ref(`${this.path}/${id}`).set(null)
    },
    // formatNote (string = '') {
    //   return marked(string)
    // },
    handleEditNote (note) {
      this.note = note.note
      this.editId = note.id
      this.$vuetify.goTo(0)
    },
    handleCancelEdit () {
      this.note = ''
      this.editId = null
    },
    handleEditorKeydown (e) {
      if (e.ctrlKey && e.code === 'Enter') this.handlePostNote()
    }
    // save () {
    //   this.isDirty = false
    //   rtdb.ref(this.path).set(this.notes)
    // },
    // onResize () {
    //   let el = this.$refs.wrapper
    //   let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    //   if (el) this.top = el.getBoundingClientRect().top + scrollTop
    // }
  }
}
</script>

<style lang="scss">
.si-note-body {
  color: rgba(0,0,0,.87) !important;
}


</style>
